import React from 'react'
import _ from 'lodash'
import queryString from 'query-string'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { withDevice } from '@blazar-plugins/device'
import EducationPlacement from 'external/BlocketUtbildning/EducationPlacement'
import { OnboardingBanner } from 'components/OnboardingBanner'
import Toplistings from 'external/Toplistings'

import TabBar from 'components/TabBar'
import ErrorComponent from 'components/ErrorComponent'
import Pagination from 'components/Pagination'
import Footer from 'components/Footer'

import QuickLinks from 'components/QuickLinks'
import SearchHeader from './SearchHeader'
import SearchResults from './SearchResults'
import EmptyStateList from './EmptyStateList'
import ShippingAds from './ShippingAds'
import FilterSave from './FilterSave'
import ArchivedAdNotification from './ArchivedAdNotification'
import GoogleAdsense from './GoogleAdsense/GoogleAdsense'
import BostadRentLink from './BostadRentLink'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  flex: 1;
`

const ListFooter = styled.div`
  padding-bottom: 16px;
  padding-top: 16px;
  background: #f9f7f6;
`

const PaginationWrapper = styled.div`
  padding-left: 16px;
  padding-right: 16px;
  margin-bottom: 40px;
`

const StyledEmptyState = styled.div`
  padding: 60px 16px;
`

const StyledArchivedAdNotification = styled(ArchivedAdNotification)`
  border-bottom: 1px solid #dfdede;
`

export const SmallLayout = ({
  error,
  errorId,
  haveSearchResults,
  isFetching,
  searchTotal,
  totalPageCount,
  hitsPerPage,
  firstFetch,
  location,
  urls,
  searchSubsetDescription,
  searchResultDescription,
  searchParamsActions,
  breadcrumbs,
  searchParametersDefinition,
  geoPref,
  device,
  classifiedActions,
  filterQuery,
  inventory,
  shippingAds,
}) => {
  const queryParams = queryString.parse(location.search)
  const currentPage = Number(_.get(queryParams, 'page', 1))
  const { sh } = searchParametersDefinition || {}
  const loading = firstFetch || isFetching
  const showEmptyState = !haveSearchResults && !loading

  if (error) {
    return <ErrorComponent error={errorId} />
  }
  const child = (
    <>
      {sh && <OnboardingBanner />}
      {queryParams.cg === '1020' && (
        <OnboardingBanner
          isPayment
          cookieKey="hidePaymentOnboarding"
          title="Trygg betalning för alla!"
          text="Nu gör vi det tryggare och smidigare att köpa och sälja på Blocket."
          readmoreText="Läs mer om Blocketbetalning"
          readmoreUrl="/trygg-betalning-pa-blocket"
        />
      )}
      <FilterSave
        searchResultDescription={searchResultDescription}
        location={location}
        loading={loading}
      />
      <StyledArchivedAdNotification />
      {haveSearchResults && !loading && <Toplistings />}
      {showEmptyState ? (
        <>
          <StyledEmptyState>
            <EmptyStateList shippingAds={shippingAds} />
          </StyledEmptyState>
          <GoogleAdsense
            layout="small"
            emptySearchResults={!haveSearchResults}
            label="Kanske intressant istället?"
          />
        </>
      ) : (
        <SearchResults
          loading={loading}
          device={device}
          totalPageCount={totalPageCount}
          currentPage={currentPage}
        />
      )}
      <ShippingAds layout="small" loading={loading} device={device} />
      {!showEmptyState && (
        <>
          <GoogleAdsense device={device} layout="small" label="Liknande produkter från Google" />
          <ListFooter>
            <PaginationWrapper>
              <Pagination
                totalPageCount={totalPageCount}
                currentPage={Number(_.get(queryParams, 'page', 1))}
                hitCount={searchTotal}
                hitsPerPage={hitsPerPage}
                classifiedActions={classifiedActions}
              />
            </PaginationWrapper>
          </ListFooter>
        </>
      )}
    </>
  )

  return (
    <Container>
      <TabBar />
      <main>
        <SearchHeader
          style={{ zIndex: 10 }}
          breadcrumbs={breadcrumbs}
          searchParametersDefinition={searchParametersDefinition}
          searchSubsetDescription={searchSubsetDescription}
          searchParamsActions={searchParamsActions}
          geoPref={geoPref}
          filterQuery={filterQuery}
        />
        <BostadRentLink cg={queryParams.cg} />
        {queryParams.cg === '7093' && <EducationPlacement baseUrl={urls.desktop} />}
        {child}
        <QuickLinks inventory={inventory} />
      </main>
      <Footer />
    </Container>
  )
}

SmallLayout.propTypes = {
  error: PropTypes.bool.isRequired,
  errorId: PropTypes.string,
  isFetching: PropTypes.bool.isRequired,
  haveSearchResults: PropTypes.bool,
  searchTotal: PropTypes.number.isRequired,
  totalPageCount: PropTypes.number.isRequired,
  hitsPerPage: PropTypes.number.isRequired,
  firstFetch: PropTypes.bool.isRequired,
  location: PropTypes.object.isRequired,
  urls: PropTypes.object.isRequired,
  searchParamsActions: PropTypes.object.isRequired,
  searchResultDescription: PropTypes.node,
  breadcrumbs: PropTypes.array,
  searchSubsetDescription: PropTypes.string,
  searchParametersDefinition: PropTypes.object,
  device: PropTypes.shape({ is: PropTypes.func.isRequired }).isRequired,
  geoPref: PropTypes.object,
  classifiedActions: PropTypes.object,
  filterQuery: PropTypes.object,
  inventory: PropTypes.object,
  shippingAds: PropTypes.object.isRequired,
}

export default withDevice(SmallLayout)
